import React from "react";
import { InsTagBadgeList } from "components/tags/insTagBadge";
export const TagsCellRenderer = (props) => React.createElement("span", { className: "tagListInGrid" },
    React.createElement(InsTagBadgeList, { tags: props.data?.tags || [] }));
